import { getQuery } from '@util'
import { isWPSClient, getIsTeach } from '@util/wpsoffice'

export const isEduEnvSync = () => {
  const eduUtmSources = ['WPS365_EDU_WEB', 'WPS365_EDU_PC']
  return eduUtmSources.indexOf(getQuery('utm_source')) > -1
}

export const isEduEnv = async () => {
  if (isEduEnvSync()) {
    return true
  }
  if (window.isEduWPSClient !== undefined) {
    return window.isEduWPSClient
  }
  try {
    const isEduWPSClient = isWPSClient() && (await getIsTeach())
    window.isEduWPSClient = isEduWPSClient
    return !!isEduWPSClient
  } catch (e) {
    window.isEduWPSClient = false
    return false
  }
}
